<h4>{{entity.PageCaption}}</h4>
<!-- <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li [ngClass]="menu.Link && menu.Link != '' ? 'breadcrumb-item' : 'breadcrumb-item active'"
            *ngFor="let menu of menuList" (click)="menu.Link && menu.Link != '' && navigateToLink(menu)"> 
            <span [ngClass]="menu.Link && menu.Link != '' ? 'breadcrumb-item' : 'breadcrumb-item active br-btn'"><i
                    class="hm-ic" [ngClass]="menu.IconClass"></i> {{menu.Caption}}</span>
            <i class="fa fa-angle-right" aria-hidden="page"></i>
        </li>
    </ol>
</nav> -->